import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { trpc } from '../../trpc';
import { useUser } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';
import { ApplicationsTab } from '@/components/dashboard/ApplicationsTab';
import { waitForClerk } from '@/utils/clerk';

export const Route = createFileRoute('/dashboard/applications')({
  component: ApplicationsContent,
  beforeLoad: async () => {
    // Wait for Clerk to load
    const user = await waitForClerk();
    if (!user) {
      return redirect({
        to: '/',
        replace: true,
      });
    }
  },
});

function ApplicationsContent() {
  const { t } = useTranslation();
  const { user } = useUser();
  const userId = user?.id;

  // Get applications from the backend
  const applicationsQuery = trpc.applications.getAll.useQuery(
    { userId: userId || '' },
    {
      retry: 2,
      retryDelay: 500,
      onError: (error: Error) => {
        console.error('Applications query error:', error);
        Sentry.captureException(error, {
          tags: { component: 'ApplicationsContent', action: 'applicationsQuery', userId },
        });
      },
      enabled: !!userId,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 10000,
      refetchInterval: 30000,
    }
  );

  return (
    <>
      {applicationsQuery.isLoading ? (
        <p>{t('dashboard.loadingApplications')}</p>
      ) : applicationsQuery.error ? (
        <p className='text-red-500'>
          {t('common.genericError', 'Something went wrong. Please try again.')}
        </p>
      ) : (
        <>
          <ApplicationsTab applicationsQuery={applicationsQuery} t={t} />
        </>
      )}
    </>
  );
}
